<template>
  <div ref="footerContent">
    <slot />
  </div>
</template>

<script>
/**
 * This component allows you to automatically hoick whatever you pass in its default slot into the nearest Dialog
 * footer slot.
 *
 * ** Important!: **
 *
 * This component should be used as a last resort in instances where you have nested components within
 * a dialog that need to provide their own dialog footer contents.
 * Normally, you should just use the #footer slot provided by the Dialog component.
 */
export default {
  name: 'DialogFooter',
  mounted() {
    this.$nextTick(() => {
      this.nearestDialogFooter().appendChild(this.$refs.footerContent);
    });
  },
  beforeDestroy() {
    this.nearestDialogFooter().replaceChildren();
  },
  methods: {
    nearestDialogFooter() {
      return this.$refs.footerContent
        .closest('.shiftie-dialog')
        .querySelector('.dialog-footer');
    },
  },
};
</script>

<style scoped></style>
